module.exports = __webpack_public_path__ + "img/services-details-2.f044dfe0.jpg";